// extracted by mini-css-extract-plugin
export default {"line":"GgQNe39Aahqx4_zASbBh","row":"KIJfBinIPnSpRpWPeX_B","col":"mNsQbn_pHjePcGqvhIrh","placeHolderShimmer":"a3RyrVLKA8Re72X91GGj"};